import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable()
export class SharedEligibilityService {
  public dataSubject = new Subject<any>();

  setPayer(newData: any) {
    this.dataSubject.next(newData);
  }
}



// WEBPACK FOOTER //
// ./src/components/payers/eligibility/shared-eligibility.ts